module.exports = __webpack_public_path__ + "static/media/minotavirtualsinbc.8d94a110.png";